module.exports = __webpack_public_path__ + "media/images/kent-9da9c7160c3e945e90ab4e5167a9a466.jpg";